import React, {Component} from 'react';
import _ from 'lodash';
import {Icon, Table, Popup} from 'semantic-ui-react';

class ItemTable extends Component {
  getMaximumNumberPeopleByZone(zoneCode) {
    const {zonesList} = this.props;
    if (!zonesList.length) {
      return 0;
    }
    const zoneInfo = _.find(zonesList, {'code': zoneCode});
    return zoneInfo && zoneInfo.people ? zoneInfo.people : 0;
  }

  renderHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>Zona</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Etiquetas</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Personal</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderAlarm(showAlarmInPeopleField) {
    if (showAlarmInPeopleField) {
      return (
        <Popup
          trigger={<Icon link name='warning sign' color='red' size='big' />}
          on='click'
          position='bottom left'
          inverted
        >
          <div>Excedente de Personal</div>
        </Popup>
      );
    }
  }

  renderZones() {
    const {shiftData} = this.props;
    const pickingZones = shiftData.pickingZones || [];

    if (!pickingZones.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='4'>
            No hay zonas disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return pickingZones.map((pickingZone, index) => {
      const maximumNumberPeopleByPickingOrderType =
        this.getMaximumNumberPeopleByZone(pickingZone.code);
      const showAlarmInPeopleField =
        pickingZone.people > maximumNumberPeopleByPickingOrderType ?
          'alert' :
          '';

      return (
        <Table.Row key={index} className={showAlarmInPeopleField}>
          <Table.Cell textAlign='center'>{pickingZone.name}</Table.Cell>
          <Table.Cell textAlign='center'>{pickingZone.labels}</Table.Cell>
          <Table.Cell textAlign='center'>{pickingZone.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderAlarm(showAlarmInPeopleField)}
            {pickingZone.people}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        {this.renderHeader()}
        <Table.Body>
          {this.renderZones()}
        </Table.Body>
      </Table>
    );
  }
}

export default ItemTable;
